import React from 'react';
import ReactDOM from 'react-dom/client';
import AdminApp from './AdminApp';

// Initialize the admin application
const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AdminApp />
  </React.StrictMode>
);